import { getSDLHeaderSelector } from '@pes-ui/utils';
import { BANNER_STYLES_BY_CONTEXT } from './constants';
export const getContainer = (target) => {
  let container;
  if (target === 'header') {
    container = document.querySelector(getSDLHeaderSelector());
  }
  if (!container) {
    container = document.body;
  }
  return container;
};
export const getStyles = (target) => {
  return { style: BANNER_STYLES_BY_CONTEXT[target] };
};
